import { Store } from 'redux'
import { ActionsObservable } from 'redux-observable'
import { Observable } from 'rxjs'

import { draftRelatedContentToAns } from '~/reactapp/story/draft-to-ans'
import { toRelatedContent } from '~/reactapp/story/import/ansToDraftContent'
import denormalizer from '~/reactapp/story/util/denormalizer'
import { IANSReference } from '~/types'

import {
  actionTypes,
  relatedContent as getRelatedContent,
  setRelatedContent,
} from '../draftEditor'
import {
  ActionTypes,
  IActionDenormalizeRelatedContent,
  IActionSetRelatedContent,
  IDraftRelatedContent,
  IEllipsisReduxStore,
} from '../types'

type OutputActions = IActionSetRelatedContent

export default function denormalizeRelatedContentEpic(
  action$: ActionsObservable<ActionTypes>,
  store: Store<IEllipsisReduxStore>
): Observable<OutputActions> {
  return action$
    .ofType(actionTypes.ACTION_DENORMALIZE_RELATED_CONTENT)
    .mergeMap<IActionDenormalizeRelatedContent, OutputActions>(() => {
      const currentRelatedContentState: IDraftRelatedContent = getRelatedContent(
        store.getState()
      )
      return (
        Observable.of(currentRelatedContentState)
          .map<IDraftRelatedContent, IANSReference[]>((relatedContentState) =>
            draftRelatedContentToAns(
              relatedContentState.data as Pick<IDraftRelatedContent, 'data'>
            )
          )
          .flatMap<IANSReference[], object[]>((relatedContentRaw) =>
            Observable.from(denormalizer(relatedContentRaw))
          )
          .map<object[], IDraftRelatedContent>((denormed) =>
            toRelatedContent({
              // eslint-disable-next-line @typescript-eslint/camelcase
              related_content: {
                basic: denormed,
              },
            })
          )
          .map<IDraftRelatedContent, OutputActions>(
            (denormedDraftRelatedContent) =>
              setRelatedContent({
                data: denormedDraftRelatedContent,
                isDenormalizing: false,
                hasError: false,
              })
          )
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .catch<any, OutputActions>(() => {
            return Observable.of(
              setRelatedContent({
                ...currentRelatedContentState,
                isDenormalizing: false,
                hasError: true,
              })
            )
          })
      )
    })
}
